export default __webpack_public_path__ + "static/media/project-wizard-eapp-rules.ae892074.png";